module.exports = __webpack_public_path__ + "media/slider/WelcomeToComposzIndia-3c7f0d24.jpg";